import { cn } from '@tempo-io/sui-class-utils';
import { Tooltip, TooltipContent, TooltipTrigger } from '@tempo-io/sui-tooltip';
import type { ReactNode } from 'react';

interface TooltipIconButtonProps {
  icon: ReactNode;
  tooltipText: string;
  ariaLabel?: string;
  onClick?: () => void;
  className?: string;
  contentClassName?: string;
  side?: 'left' | 'right' | 'top' | 'bottom';
  disabled?: boolean;
  testId?: string;
}

export const TooltipIconButton = ({
  icon,
  tooltipText,
  ariaLabel,
  onClick,
  className,
  contentClassName,
  side = 'left',
  disabled = false,
  testId,
}: TooltipIconButtonProps) => (
  <Tooltip>
    <TooltipTrigger asChild>
      <button
        data-testid={testId}
        type="button"
        className={cn(
          'inline-flex p-2',
          disabled ? 'cursor-not-allowed opacity-60' : 'cursor-pointer',
          className,
        )}
        onClick={disabled ? (e) => e.preventDefault() : onClick}
        aria-label={ariaLabel ?? tooltipText}
        aria-disabled={disabled}
      >
        {icon}
      </button>
    </TooltipTrigger>
    <TooltipContent side={side} className={contentClassName}>
      <p>{tooltipText}</p>
    </TooltipContent>
  </Tooltip>
);
